import { render, staticRenderFns } from "./InstanceBase.vue?vue&type=template&id=53fe4b99&"
import script from "./InstanceBase.vue?vue&type=script&lang=js&"
export * from "./InstanceBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports